import { ROLES } from '@/constants/roles';

export const uiPartnersMain = {
  path: '/partners/active',
  name: 'ui-partners-active',
  meta: {
    title: 'Партнёры',
    accessList: [ROLES.expert],
  },
};

export default [
  {
    path: '/partners',
    name: 'ui-partners',
    component: () => import('./views/partners-main.vue'),
    meta: {
      layout: 'ui-design',
      accessList: [ROLES.expert],
    },
    redirect: { name: 'ui-partners-active' },
    children: [
      {
        path: 'invitations',
        name: 'ui-partners-invitations',
        redirect: { name: 'ui-partners-active' },
      },
      {
        path: 'active',
        name: 'ui-partners-active',
        component: () => import('@/modules/Partners/views/partners-active/index.vue'),
        meta: {
          title: 'Активные',
          layout: 'ui-design',
          accessList: [ROLES.expert],
        },
      },
    ],
  },
];
